export const BOARD_YJS_ADMIN_MAP_NAMES = [
  'assets',
  'clips',
  'jobs',
  'upscaleJobs',
  'tracks',
  'meta',
  'canvasPositions',
  'scenes',
  'takeCustomizations',
  'assetInOutPoints',
  'sequences',
  'sequenceFrames',
  'sequenceFolders',
  'canvasBins',
  'textAnnotations',
  'draftSettings',
  'mediaBins',
  'setNames',
  'assetNames',
  'characterTransforms',
  'setCameraStates',
  'elementCanvasNodes',
  'characterCanvasNodes',
  'setSubjectPlacements',
  'subjectCollections',
  'variationStacks',
  'variableCanvasNodes',
  'actions',
  'workflows',
  'workflowRunStatuses',
  'comments',
] as const

export type BoardYjsAdminMapName = (typeof BOARD_YJS_ADMIN_MAP_NAMES)[number]

export const BOARD_YJS_FRONTEND_BROAD_SYNC_MAP_NAMES = [
  'assets',
  'clips',
  'jobs',
  'tracks',
  'canvasPositions',
  'scenes',
  'takeCustomizations',
  'assetInOutPoints',
  'draftSettings',
  'sequences',
  'sequenceFrames',
  'sequenceFolders',
  'mediaBins',
  'setNames',
  'assetNames',
  'canvasBins',
  'variationStacks',
  'textAnnotations',
  'subjectCanvasNodes',
  'subjectCollections',
  'variableCanvasNodes',
  'actions',
  'workflows',
  'setSubjectPlacements',
  'comments',
] as const

export type BoardYjsFrontendBroadSyncMapName = (typeof BOARD_YJS_FRONTEND_BROAD_SYNC_MAP_NAMES)[number]

export const BOARD_YJS_TARGETED_OBSERVER_MAP_NAMES = [
  'characterTransforms',
  'setCameraStates',
  'upscaleJobs',
  'workflowRunStatuses',
] as const

export type BoardYjsTargetedObserverMapName = (typeof BOARD_YJS_TARGETED_OBSERVER_MAP_NAMES)[number]

export const BOARD_YJS_FRONTEND_TO_PERSISTED_MAP_ALIASES = {
  subjectCanvasNodes: 'elementCanvasNodes',
} as const

export function isBoardYjsAdminMapName(mapName: string): mapName is BoardYjsAdminMapName {
  return (BOARD_YJS_ADMIN_MAP_NAMES as readonly string[]).includes(mapName)
}

export function getPersistedBoardYjsMapName(frontendMapName: BoardYjsFrontendBroadSyncMapName): BoardYjsAdminMapName {
  if (frontendMapName in BOARD_YJS_FRONTEND_TO_PERSISTED_MAP_ALIASES) {
    return BOARD_YJS_FRONTEND_TO_PERSISTED_MAP_ALIASES[
      frontendMapName as keyof typeof BOARD_YJS_FRONTEND_TO_PERSISTED_MAP_ALIASES
    ]
  }
  return frontendMapName as BoardYjsAdminMapName
}
